(function () {
  function transitDaysFromAgra(pincode, origin, fallback) {
    const p = String(pincode).padStart(6, '0');
    if (!/^\d{6}$/.test(p)) return null;
    const prefix = parseInt(p.slice(0, 3), 10);

    if (p === String(origin).padStart(6, '0')) return 1;
    if (p.startsWith('282')) return 2;
    if (prefix >= 110 && prefix <= 110) return 2;
    if (prefix >= 201 && prefix <= 203) return 2;
    if (prefix >= 200 && prefix <= 285) return 3;
    if (prefix >= 140 && prefix <= 199) return 4;
    if (prefix >= 300 && prefix <= 345) return 4;
    if (prefix >= 360 && prefix <= 445) return 5;
    if (prefix >= 500 && prefix <= 695) return 6;
    if (prefix >= 700 && prefix <= 793) return 6;
    if (prefix >= 790 && prefix <= 799) return 8;
    return fallback;
  }

  function addBusinessDays(start, days) {
    const date = new Date(start);
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0) added++;
    }
    return date;
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  }

  function initEstimator(root) {
    const input = root.querySelector('.product-delivery-estimator__input');
    const btn = root.querySelector('.product-delivery-estimator__btn');
    const result = root.querySelector('.product-delivery-estimator__result');
    if (!input || !btn || !result) return;

    const origin = root.dataset.originPincode || '282001';
    const processing = parseInt(root.dataset.processingDays || '1', 10);
    const fallback = parseInt(root.dataset.shipDaysDefault || '5', 10);

    function runCheck() {
      const pin = input.value.replace(/\D/g, '');
      if (pin.length !== 6) {
        result.hidden = false;
        result.textContent = 'Please enter a valid 6-digit pincode.';
        result.classList.add('is-error');
        return;
      }
      const transit = transitDaysFromAgra(pin, origin, fallback);
      if (transit === null) {
        result.hidden = false;
        result.textContent = 'Please enter a valid 6-digit pincode.';
        result.classList.add('is-error');
        return;
      }
      const totalDays = processing + transit;
      const deliveryDate = addBusinessDays(new Date(), totalDays);
      result.hidden = false;
      result.classList.remove('is-error');
      result.innerHTML =
        '<strong>Estimated delivery:</strong> ' +
        formatDate(deliveryDate) +
        ' <span class="product-delivery-estimator__meta">(' +
        totalDays +
        ' business days from Agra)</span>';
      try {
        localStorage.setItem('ratnora_pincode', pin);
      } catch (e) {}
    }

    btn.addEventListener('click', runCheck);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        runCheck();
      }
    });

    try {
      const saved = localStorage.getItem('ratnora_pincode');
      if (saved && saved.length === 6) {
        input.value = saved;
        runCheck();
      }
    } catch (e) {}
  }

  function initAll() {
    document.querySelectorAll('.product-delivery-estimator').forEach(initEstimator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
